import { useEffect, useState } from "react";
import { Sparkle } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

// Loads MaSa's ready draft for Hot (reply) and Waiting (nudge) conversations into the reply box.
export const useSuggestion = (id, view, setReply) => {
  const [state, setState] = useState({ loading: false, kind: null, error: null, text: null });
  const eligible = view?.view === "prospect" && ["hot", "waiting"].includes(view?.stage);
  const load = async (fresh = false) => {
    setState({ loading: true, kind: null, error: null, text: null });
    try {
      const { data } = await api.get(`/threads/${id}/suggestion${fresh ? "?fresh=true" : ""}`);
      const s = data.suggestion;
      if (s?.text) setReply((cur) => (fresh || !cur ? s.text : cur));
      setState({ loading: false, kind: s?.kind || null, error: null, text: s?.text || null });
    } catch (e) {
      setState({ loading: false, kind: null, error: errMsg(e), text: null });
    }
  };
  useEffect(() => { if (eligible) load(); }, [id, eligible]); // eslint-disable-line react-hooks/exhaustive-deps
  // thread moved out of Hot/Waiting: drop an untouched draft so it can't be sent by mistake
  useEffect(() => { if (!eligible && state.text) { setReply((cur) => (cur === state.text ? "" : cur)); setState((x) => ({ ...x, text: null })); } }, [eligible]); // eslint-disable-line react-hooks/exhaustive-deps
  return { ...state, eligible, regenerate: () => load(true) };
};

export const SuggestionBar = ({ s }) => {
  if (!s.eligible) return null;
  const label = s.loading ? "MaSa is drafting..." : s.error ? `Couldn't draft: ${s.error}` : s.kind === "nudge" ? "MaSa drafted a friendly nudge - check it, then send" : "MaSa drafted this reply - check it, then send";
  return (
    <div className="flex items-center gap-2 text-xs" data-testid="suggestion-bar">
      <Sparkle size={14} className="text-[#007AFF]" />
      <span className={s.error ? "text-red-400" : "text-zinc-400"} data-testid="suggestion-label">{label}</span>
      <Button size="sm" variant="ghost" className="h-7 ml-auto text-xs" disabled={s.loading} onClick={s.regenerate} data-testid="suggestion-regenerate-btn">Write a new draft</Button>
    </div>
  );
};
